import Accounting from "accounting";
import PropTypes from "prop-types";
import React from "react";
import { MenuItem, DropdownButton } from "react-bootstrap";

import UserStore from "../../stores/UserStore";

import AccountingHelper from "../../utils/AccountingHelper";

export default class NegativeAmountDisplaySetting extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = NegativeAmountDisplaySetting.getStoreState();
		this._onChange = this._onChange.bind(this);
		this.handleFormatChange = this.handleFormatChange.bind(this);
	}

	static getStoreState()
	{
		let format = UserStore.getUserProfileSetting("format");
		if (!format)
		{
			const currentFormat = Accounting.settings.currency.format;
			if (typeof currentFormat === "string")
			{
				let selectedFormat = AccountingHelper.formats.find(format => format.name === currentFormat);
				if (!selectedFormat)
				{
					selectedFormat = AccountingHelper.formats.find(format => format.isDefault);
				}
				format = selectedFormat.name;
			}
			else if (typeof currentFormat === "object")
			{
				format = currentFormat.neg;
			}
		}
		return {
			format
		};
	}

	async handleFormatChange(setFormat)
	{
		await AccountingHelper.setFormat(setFormat);
		this.setState({format: setFormat});
	}

	_onChange()
	{
		this.setState(NegativeAmountDisplaySetting.getStoreState());
	}

	componentDidMount()
	{
		UserStore.addChangeListener(this._onChange);
	}

	componentWillUnmount()
	{
		UserStore.removeChangeListener(this._onChange);
	}

	render()
	{
		const selectedFormatName = this.state.format;
		let enabled = this.props.enabled;

		let selectedFormat = AccountingHelper.formats.find(format => format.name === selectedFormatName);
		const title = selectedFormat ? selectedFormat.displayName : selectedFormatName;

		return (
			<DropdownButton
				onSelect={this.handleFormatChange}
				title={title}
				id="currencyFormatChange"
				disabled={!enabled}
			>
				{AccountingHelper.formats.map(format => {
					return (
						<MenuItem
							key={format.name}
							eventKey={format.name}
							className={format.name === selectedFormatName ? "active" : ""}
						>
							{format.displayName}
						</MenuItem>
					);
				})}
			</DropdownButton>
		);
	}
}

NegativeAmountDisplaySetting.propTypes = {
	enabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./Components/components/settings/NegativeAmountDisplaySetting.jsx